import { defineStore } from 'pinia';
import { useDepartmentStore } from '@/stores/department';
import { getUniqueInstitutions } from '@/utils/helpers';
import { IInstitution } from '@/interfaces';
import { NewsUnionFragment } from '@/graphql/generated-types';
import api from '@/api';
import { addMonths } from 'date-fns';

export const useNewsStore = defineStore('news', {
  state: () => ({
    all: [] as NewsUnionFragment[],
    allCopy: [] as NewsUnionFragment[],
    uniqueInstitutions: [] as IInstitution[],
  }),
  actions: {
    async getNews() {
      const departmentStore = useDepartmentStore();

      if (!departmentStore.id) {
        throw new Error('No department id provided');
      }

      try {
        const dateFrom = new Date();
        const dateTo = addMonths(dateFrom, 3);
        const news = await api.news.getNews(
          dateFrom,
          dateTo,
          departmentStore.id
        );
        this.all = news;
        this.allCopy = news;
        this.uniqueInstitutions = getUniqueInstitutions(news);
      } catch (error) {
        console.log('Error getting news', error);
      }
    },
  },
});
